import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {PatronBalanceTransaction} from '@store/balance/balance.types';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {BalanceSelectors} from '@store/balance/balance.selectors';

@Component({
  selector: 'px-expanded-transaction-names',
  host: {
    class: 'text-body-medium md:text-body-small'
  },
  template: `
    @for (balanceLine of transactionSelectors.sortedBalanceLinesFor(transaction) | select; track balanceLine.id) {
      <div mxTruncate>
        {{ transactionLineSelectors.nameFor(balanceLine) | select }}
        ({{ transactionLineSelectors.targetFor(balanceLine) | select | format:'TITLE_CASE' }})
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormatPipe, SelectPipe, TruncateDirective]
})
export class ExpandedTransactionNamesComponent {
  @Input({required: true}) transaction: PatronBalanceTransaction;

  public readonly transactionSelectors = BalanceSelectors.BalanceTransactions;
  public readonly transactionLineSelectors = BalanceSelectors.BalanceTransactionLines;
}
